import moment from "moment";
import {formatDateFromLocal} from "./formatDate";

export const STATUS_PHONE = ['LOGOUT', 'AVAILABLE', 'OUTBOUND', 'OFFLINE']
export const MAP_STATUS = {
    1: 'One',
    2: 'Two',
    3: 'Three',
    4: 'Four',
    5: 'Five'
}

export const TYPE_TALK_TIME = [
    {
        name: "Ngày",
        value: "DAY"
    },
    {
        name: "Tháng",
        value: "MONTH"
    },
    {
        name: "Block",
        value: "BLOCK"
    },
    {
        name: "Thời gian",
        value: "Time"
    }
]

export const TYPE_CALL_OUT = [
    {
        name: "Mở",
        value: "OPEN"
    },
    {
        name: "Khóa",
        value: "LOCK"
    },
]

export const DATA_FILTER_TASKS = {
    'default': {value: 'default', title: 'Tất cả task', filters: {status: '', dueDate: ''}},
    'today': {value: 'today', title: 'Đến hạn hôm nay', filters: {status: '', dueDate: formatDateFromLocal(moment())}},
    'openOver': {
        value: 'openOver',
        title: 'Đang mở & quá hạn',
        filters: {status: 'Open', dueDate: formatDateFromLocal(moment())}
    },
    'open': {value: 'open', title: 'Tất cả đang mở', filters: {status: 'Open', dueDate: ''}},
    'close': {value: 'close', title: 'Tất cả đã đóng', filters: {status: 'Close', dueDate: ''}},
}